import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CloneDeepPipe } from './pipes/clone-deep.pipe';
import { ClonePipe } from './pipes/clone.pipe';
import { IncludesPipe } from './pipes/includes.pipe';
import { IsNilPipe } from './pipes/is-nil.pipe';
import { ReversePipe } from './pipes/reverse.pipe';
import { SplitPipe } from './pipes/split.pipe';
import { TrimPipe } from './pipes/trim.pipe';
import { CastArrayPipe } from './pipes/cast-array.pipe';
import { CamelCasePipe } from './pipes/camel-case.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { RoundPipe } from './pipes/round.pipe';
import { InitialPipe } from './pipes/initial.pipe';
import { TailPipe } from './pipes/tail.pipe';
import { DifferenceByPipe } from './pipes/difference-by.pipe';
import { FlowPipe } from './pipes/flow.pipe';

const publicApi = [
  CloneDeepPipe,
  ClonePipe,
  DifferenceByPipe,
  FlowPipe,
  IncludesPipe,
  IsNilPipe,
  ReversePipe,
  SplitPipe,
  TrimPipe,
  CastArrayPipe,
  CamelCasePipe,
  KeysPipe,
  RoundPipe,
  InitialPipe,
  TailPipe,
];

@NgModule({
  imports: [CommonModule, ...publicApi],
  exports: [...publicApi],
})
export class NgLodashModule {}
